import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import SidebarHeader from "./sub/SidebarHeader";
import MenuItem from "./sub/MenuItem";

interface SidebarProps {
  isMobileOpen: boolean;
  onMobileClose: () => void;
}

const menuSections = [
  {
    title: "Principale",
    items: [{ name: "Tableau de bord", icon: "LayoutDashboard", path: "/user/dashboard/home" }],
  },
  {
    title: "Mes Achats",
    items: [
      { name: "Mes commandes", icon: "ShoppingBag", path: "/user/dashboard/commands" },
      { name: "Mes paiements", icon: "Receipt", path: "/user/dashboard/paiements" },
      { name: "Mes produits", icon: "Package", path: "/user/dashboard/products" },

    ],
  },
  {
    title: "Compte",
    items: [
      { name: "Mon profil", icon: "User", path: "/user/dashboard/profile" },
      
      { name: "Sécurité", icon: "Shield", path: "/user/dashboard/security" },
      
    ],
  },
 
  
];

const Sidebar: React.FC<SidebarProps> = ({ isMobileOpen, onMobileClose }) => {
  return (
    <>
      <AnimatePresence>
        {isMobileOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onMobileClose}
            className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm lg:hidden"
          />
        )}
      </AnimatePresence>

      <aside
        className={`
          fixed top-0 left-0 z-50 h-full w-[280px] 
          bg-gradient-to-b from-green-900 to-green-900
          backdrop-blur-sm
          border-r border-accent/20
          shadow-2xl shadow-black/20
          transition-transform duration-300 ease-in-out
          ${isMobileOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}
        `}
      >
        <div className="flex flex-col h-full relative">
          <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-accent/5 to-transparent pointer-events-none" />
          <SidebarHeader />
          <nav className="flex-1 overflow-y-auto persosrcollbar px-3 py-6 scrollbar-thin scrollbar-thumb-accent/30 scrollbar-track-transparent">
            {menuSections.map((section, idx) => (
              <div key={idx} className="mb-6">
                <h3 className="text-[11px] font-bold uppercase tracking-wider text-accent/70 mb-2 ml-2">
                  {section.title}
                </h3>
                <div className="space-y-1">
                  {section.items.map((item) => (
                    <MenuItem
                      key={item.name}
                      item={item}
                      onMobileClose={onMobileClose}
                    />
                  ))}
                </div>
              </div>
            ))}
          </nav>
          <div className="p-4 border-t border-accent/20 text-start">
            <p className="text-[10px] text-white/70">🌿 L'efficacité des Psaumes et Plantes – v1.0</p>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;